/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  firebase: {
    projectId: 'match-a-movie',
    appId: '1:492025193954:web:4b7a7414d1b163de3745bb',
    databaseURL: 'https://match-a-movie-default-rtdb.firebaseio.com',
    storageBucket: 'match-a-movie.appspot.com',
    apiKey: 'AIzaSyC151f6rKEsu3HzeunsiNuB6aBpp0eZjYE',
    authDomain: 'match-a-movie.firebaseapp.com',
    messagingSenderId: '492025193954',
    measurementId: 'G-NMCFLLV5NY',
  },
  production: false,
};
